import { handlePermission } from '@/utils/permission'
const MyPlugin = {
  install(Vue, options) {
    // v-enter-number 调用
    Vue.directive('enterNumber', {
      inserted: function(el) {
        el.addEventListener('keypress', function(e) {
          e = e || window.event
          const charcode = typeof e.charCode === 'number' ? e.charCode : e.keyCode
          const re = /\d/
          if (!re.test(String.fromCharCode(charcode)) && charcode > 9 && !e.ctrlKey) {
            if (e.preventDefault) {
              e.preventDefault()
            } else {
              e.returnValue = false
            }
          }
        })
      }
    })
    Vue.prototype.$handlePermission = handlePermission
  }
}

export default MyPlugin
